import { lazy } from 'react';
import { MultiApp } from '@/config/context';
import { IRouteConfig } from '../types';

export const resourceManageRoutes = (): IRouteConfig[] => [
  {
    path: '/resource-manage',
    exact: true,
    name: '资源包',
    component: lazy(() => import('@/presentation/pages/resource-manage')),
    hideInMenu: true,
    whitelisted: true,
    pmWhitelisted: true,
    versions: [MultiApp.Pro, MultiApp.Dji, MultiApp.Sgp, MultiApp.Eu],
  },
  {
    path: '/resource-manage-details',
    exact: true,
    name: '资源包使用明细',
    component: lazy(() => import('@/presentation/pages/resource-manage-details')),
    hideInMenu: true,
    whitelisted: true,
    pmWhitelisted: true,
    versions: [MultiApp.Pro, MultiApp.Dji, MultiApp.Sgp, MultiApp.Eu],
  },

  {
    path: '/month-resource-details',
    exact: true,
    name: '资源包使用明细',
    component: lazy(() => import('@/presentation/pages/month-resource-details')),
    hideInMenu: true,
    whitelisted: true,
    pmWhitelisted: true,
    versions: [MultiApp.Pro, MultiApp.Dji, MultiApp.Sgp, MultiApp.Eu],
  },
  {
    path: '/credit-resource-details',
    exact: true,
    name: '套餐详细使用情况',
    component: lazy(() => import('@/presentation/pages/credit-resource-details')),
    hideInMenu: true,
    whitelisted: true,
    pmWhitelisted: true,
    versions: [MultiApp.Pro, MultiApp.Dji, MultiApp.Sgp, MultiApp.Eu],
  },
];

export default resourceManageRoutes;
